//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QuestionRadio from './button/questionRadio'
import QuestionCheckbox from './button/questionCheckbox'
import QuestionBlank from './button/questionBlank'
import QuestionSection from './button/questionSection'
const Questions = [
  { type: 'questionRadio' },
  { type: 'questionCheckbox' },
  { type: 'questionBlank' },
  { type: 'questionSection' },
  { type: '' },
  { type: '' },
  { type: '' },
  { type: '' },
  { type: '' },
]
export default {
  props: {
    questionsList: {
      type: Array,
      default: () => Questions,
    },
  },
  components: {
    QuestionRadio,
    QuestionCheckbox,
    QuestionBlank,
    QuestionSection,
  },
  data() {
    return {}
  },
  methods: {
    chooseItem(item) {
      this.$emit('onchoose', item)
    },
    cancel() {
      this.$emit('popup-close')
    },
  },
}
